import { GLOBAL_CONSTANTS } from '@/constants/globalConstants'
import { getCountryDetails } from '@/utils/session'
import { createSlice } from '@reduxjs/toolkit'

const countryDetails = getCountryDetails()
const countryName =
  countryDetails?.countryName || GLOBAL_CONSTANTS.INDIA_COUNTRY
const countryCode =
  countryDetails?.countryCode || GLOBAL_CONSTANTS.INDIA_COUNTRY_CODE

const initialState = {
  countryName: countryName,
  countryCode: countryCode,
}

const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    setCountry: (state, action) => {
      state.countryName = action.payload.countryName
      state.countryCode = action.payload.countryCode
    },
    clearCountry: () => initialState,
  },
})

export const { setCountry, clearCountry } = countrySlice.actions
export default countrySlice.reducer
